module.exports = __webpack_public_path__ + "static/media/Costillasconajo.07ca9d15.jpg";